import React from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { GigBonusRedeemType } from '@lucky7ventures/bff-types';

import { isEmpty } from '@/shared/utility';
import BonusCard from '@/components/shared/bonus-card/BonusCard';
import { selectActiveBonuses } from '@/store/bonuses/selectors';
import { OpenedFrom } from '@/lib/gTagManager';
import useCreateCmsCtaData from '@/hooks/useCreateCmsCtaData';
import { useRestrictedMode } from '@/hooks/useRestrictedMode';

const ActiveBonuses = () => {
  const bonuses = useSelector(selectActiveBonuses);
  const intl = useIntl();
  const isRestricted = useRestrictedMode();
  const { createText, createAction } = useCreateCmsCtaData();

  return (
    <div className="max-w-[720px] mx-auto py-12 px-4 sm:py-16 sm:px-8">
      <div className="mb-12">
        <h1 className="mb-4 text-[30px]">{intl.formatMessage({ id: 'activeBonuses.header' })}</h1>
        <p>{intl.formatMessage({ id: 'activeBonuses.text' })}</p>
      </div>
      <div
        className="flex justify-between flex-col flex-wrap min-h-[480px] gap-4 items-center sm:items-stretch
        sm:flex-row sm:gap-8"
      >
        {!isEmpty(bonuses) && !isRestricted ? (
          bonuses.map(
            ({
              authenticatedSecondaryCtaText,
              authenticatedSecondaryCtaType,
              authenticatedSecondaryCtaLink,
              authenticatedSecondaryCtaAnchorId,
              secondaryCtaType,
              secondaryCtaLink,
              secondaryCtaAnchorId,
              secondaryCtaText,
              gigBonusId,
              image,
              promoCode,
              userBonusId,
              title,
              description,
              availableUntilDate,
              heading,
              realBonusMoney,
              bonusMoney,
              customTermsAndConditionsDescription,
            }) => {
              const ctaAction = authenticatedSecondaryCtaType
                ? createAction(
                    OpenedFrom.ActiveBonuses,
                    authenticatedSecondaryCtaType,
                    authenticatedSecondaryCtaLink,
                    authenticatedSecondaryCtaAnchorId,
                    promoCode,
                    customTermsAndConditionsDescription,
                  )
                : createAction(
                    OpenedFrom.ActiveBonuses,
                    secondaryCtaType,
                    secondaryCtaLink,
                    secondaryCtaAnchorId,
                    promoCode,
                    customTermsAndConditionsDescription,
                  );
              const ctaText = authenticatedSecondaryCtaType
                ? createText(authenticatedSecondaryCtaType, authenticatedSecondaryCtaText)
                : createText(secondaryCtaType, secondaryCtaText);

              return (
                <BonusCard
                  key={gigBonusId}
                  id={`bonus-card-${gigBonusId}`}
                  image={image}
                  bonusCode={promoCode}
                  userBonusId={userBonusId}
                  title={title}
                  desc={description}
                  availableUntilText={availableUntilDate}
                  heading={heading}
                  redeemTypeId={GigBonusRedeemType.ForfeitBonus}
                  realBonusMoney={realBonusMoney}
                  bonusMoney={bonusMoney}
                  className="!m-0"
                  ctaText={ctaText}
                  ctaOnAction={ctaAction}
                />
              );
            },
          )
        ) : (
          <p>{intl.formatMessage({ id: 'activeBonuses.noActiveBonuses' })}</p>
        )}
      </div>
    </div>
  );
};

export default ActiveBonuses;
